/**
 * Splits a combined "Bahnhofstrasse 12" into the two fields the booking API requires.
 * Same patterns as the widget's form, so an address typed here splits identically.
 * Returns an empty `street_number` when the value carries no number; the form treats that as
 * invalid rather than sending half an address.
 */
export function splitStreetAndHouseNumber(combined: string): { street: string; street_number: string } {
  const value = combined.trim();

  // Ordered, because the patterns overlap. Each needs BOTH a name and a number.
  const patterns: RegExp[] = [
    // "Bahnhofstrasse 12" / "Bahnhofstrasse 12a" / "Hauptstrasse 3-5" / "Rue du Marché 3bis"
    /^(.+?)[\s,]+(\d+[a-zA-Z0-9\-/]*)$/,
    // "221B Baker Street" — the ordinary en_US/en_GB order
    /^(\d+[a-zA-Z0-9\-/]*)[\s,]+(.+)$/,
    // "Bahnhofstr.12" — no separator at all, common in DE/CH
    /^(.*\D)(\d+[a-zA-Z0-9\-/]*)$/,
  ];

  for (const [index, pattern] of patterns.entries()) {
    const match = value.match(pattern);
    if (!match) {
      continue;
    }
    // the second pattern captures the number first
    const [street, street_number] = index === 1
      ? [match[2].trim(), match[1].trim()]
      : [match[1].trim(), match[2].trim()];

    if (street && street_number) {
      return { street, street_number };
    }
  }

  return { street: value, street_number: '' };
}
